module.exports = __webpack_public_path__ + "e28d1b4b1a434168df636b352b5616da.svg";